var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406\\u5907\\u4EFD-3",
    transform: "translate(-1222.000000, -23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u83DC\\u5355/\\u9876\\u90E8\\u5BFC\\u822A/\\u5355\\u5C42\\u5907\\u4EFD",
    transform: "translate(208.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8BA2\\u5355",
    transform: "translate(1006.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19629305e-06,4.19629293e-06 L24.0000042,4.19629293e-06 L24.0000042,24.0000042 L4.19629305e-06,24.0000042 L4.19629305e-06,4.19629293e-06 Z",
    id: "Rectangle-4117",
    fillOpacity: 0.01,
    fill: "#FFFFFF",
    opacity: 0,
    transform: "translate(12.000004, 12.000004) rotate(0.000020) translate(-12.000004, -12.000004) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(3.000000, 3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 C17.5522847,-1.01453063e-16 18,0.44771525 18,1 L18,17.8956034 C17.9999974,18.4478866 17.5522833,18.8956007 17,18.8956007 C16.853064,18.8956007 16.7079334,18.86322 16.5749326,18.8007621 C13.6206415,17.4134113 11.2663296,16.7197359 9.51199702,16.7197359 C7.70635211,16.7197359 4.99446689,17.4545832 1.37634137,18.9242779 C0.864659488,19.1321264 0.281365563,18.8858192 0.0735184552,18.3741368 C0.0249650383,18.2546069 1.57997543e-17,18.1268111 0,17.9977963 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L17,0 Z M16.4969215,1.50402546 L1.49692154,1.50402546 L1.49692154,17.2161293 C4.83027776,15.8724937 7.51288478,15.200676 9.54474258,15.200676 C11.5766004,15.200676 13.8939934,15.8211803 16.4969215,17.0621891 L16.4969215,17.0621891 L16.4969215,1.50402546 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "currentColor",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0000056,9.0000028 L11.5000056,9.0000028 C11.776148,9.0000028 12.0000056,9.22386042 12.0000056,9.5000028 L12.0000056,10.0000028 C12.0000056,10.2761452 11.776148,10.5000028 11.5000056,10.5000028 L5.0000056,10.5000028 C4.72386322,10.5000028 4.5000056,10.2761452 4.5000056,10.0000028 L4.5000056,9.5000028 C4.5000056,9.22386042 4.72386322,9.0000028 5.0000056,9.0000028 Z",
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.9,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0000056,4.5000028 L10.0000056,4.5000028 C10.276148,4.5000028 10.5000056,4.72386042 10.5000056,5.0000028 L10.5000056,5.5000028 C10.5000056,5.77614517 10.276148,6.0000028 10.0000056,6.0000028 L5.0000056,6.0000028 C4.72386322,6.0000028 4.5000056,5.77614517 4.5000056,5.5000028 L4.5000056,5.0000028 C4.5000056,4.72386042 4.72386322,4.5000028 5.0000056,4.5000028 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-8",
    fillOpacity: 0.9,
    fill: "currentColor"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.272282a860d250e1c379cf01ac9e3b33.svg";
export { ForwardRef as ReactComponent };